export default [
    "aperture-progress-profile",
    "aperture-progress-promote"
];